<div class="main-documents">
  @if (loading) {
    <div class="loading-overlay">
      <mat-spinner></mat-spinner>
    </div>
  }
  @if (groupedOfferings.length === 0) {
    <mat-accordion>
      <mat-list-item>
        <p matListItemTitle>Ainda nÃ£o foi disponibilizado nenhum documento para vocÃª.</p>
      </mat-list-item>
    </mat-accordion>
  } @else {
    <!-- Exibe os documentos por oferta de curso -->
    <mat-accordion>
      @for (group of groupedOfferings; track group.courseOfferingName) {
        <mat-expansion-panel [expanded]="groupedOfferings.indexOf(group) === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ group.courseOfferingName }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-list>
            @for (document of group.documents; track document.id) {
              <mat-list-item>
                <mat-icon matListItemIcon>picture_as_pdf</mat-icon>
                <span matListItemTitle>
                <a href="javascript:void(0);"
                   (click)="(document.documentType === 'declaracao' || document.documentType === 'certificado')
           ? openDocumentPDF(document.id, $event)
           : openDocumentPartialPDF(document.id, $event);">
                  {{ document.documentName || 'Atestado de disciplinas finalizadas' }}
                </a>
                </span>
              </mat-list-item>
            }
          </mat-list>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
</div>
